export default "__VITE_ASSET__bc669fe1__"